interface Props {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: Props) {
  if (totalPages <= 1) return null;
  return (
    <div className="bo-pagination">
      <button type="button" disabled={page === 0} onClick={() => onChange(Math.max(0, page - 1))}>
        ← Précédent
      </button>
      <span>
        Page {page + 1} / {totalPages}
      </span>
      <button
        type="button"
        disabled={page >= totalPages - 1}
        onClick={() => onChange(Math.min(totalPages - 1, page + 1))}
      >
        Suivant →
      </button>
    </div>
  );
}
